import React from 'react';

import { ListBoxOptionItem } from '../ListBox';

import { SelectTrigger } from './Trigger/Trigger';
import { TriggerProps } from './Trigger/types';

const emptyValue: ListBoxOptionItem<string>[] = [];

export type SelectStubProps<ValueType extends string> = Omit<
    TriggerProps<ValueType>,
    'value' | 'placeholder' | 'isOpened' | 'isStub' | 'isTruncated'
>;

/**
 * Компонент для отображения состояния загрузки компонента Select
 * @kind component
 */
export function SelectStub<ValueType extends string>(props: SelectStubProps<ValueType>) {
    const { width = 'auto' } = props;
    return <SelectTrigger {...props} width={width} isStub value={emptyValue} data-testid={props['data-testid']} />;
}
